import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import HashSet from '../../../../../java/util/HashSet';
import TopologyException from '../../geom/TopologyException';
import GeometryCombiner from '../../geom/util/GeometryCombiner';
import LineSegment from '../../geom/LineSegment';
import ArrayList from '../../../../../java/util/ArrayList';
import CoordinateSequenceFilter from '../../geom/CoordinateSequenceFilter';
var OverlapUnion = /*#__PURE__*/function () {
  function OverlapUnion() {
    _classCallCheck(this, OverlapUnion);
    OverlapUnion.constructor_.apply(this, arguments);
  }
  _createClass(OverlapUnion, [{
    key: "isBorderSegmentsSame",
    value: function isBorderSegmentsSame(result, env) {
      var segsBefore = this.extractBorderSegments(this._g0, this._g1, env);
      var segsAfter = new ArrayList();
      OverlapUnion.extractBorderSegments(result, env, segsAfter);
      return this.isEqual(segsBefore, segsAfter);
    }
  }, {
    key: "extractByEnvelope",
    value: function extractByEnvelope(env, geom, disjointGeoms) {
      var intersectingGeoms = new ArrayList();
      for (var i = 0; i < geom.getNumGeometries(); i++) {
        var elem = geom.getGeometryN(i);
        if (elem.getEnvelopeInternal().intersects(env)) {
          intersectingGeoms.add(elem);
        } else {
          var copy = elem.copy();
          disjointGeoms.add(copy);
        }
      }
      return this._geomFactory.buildGeometry(intersectingGeoms);
    }
  }, {
    key: "isEqual",
    value: function isEqual(segs0, segs1) {
      if (segs0.size() !== segs1.size()) return false;
      var segIndex = new HashSet(segs0);
      var _iterator = _createForOfIteratorHelper(segs1),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var seg = _step.value;
          if (!segIndex.contains(seg)) return false;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return true;
    }
  }, {
    key: "union",
    value: function union() {
      var overlapEnv = OverlapUnion.overlapEnvelope(this._g0, this._g1);
      if (overlapEnv.isNull()) {
        var g0Copy = this._g0.copy();
        var g1Copy = this._g1.copy();
        return GeometryCombiner.combine(g0Copy, g1Copy);
      }
      var disjointPolys = new ArrayList();
      var g0Overlap = this.extractByEnvelope(overlapEnv, this._g0, disjointPolys);
      var g1Overlap = this.extractByEnvelope(overlapEnv, this._g1, disjointPolys);
      var unionGeom = this.unionFull(g0Overlap, g1Overlap);
      var result = null;
      this._isUnionSafe = this.isBorderSegmentsSame(unionGeom, overlapEnv);
      if (!this._isUnionSafe) result = this.unionFull(this._g0, this._g1);else result = this.combine(unionGeom, disjointPolys);
      return result;
    }
  }, {
    key: "combine",
    value: function combine(unionGeom, disjointPolys) {
      if (disjointPolys.size() <= 0) return unionGeom;
      disjointPolys.add(unionGeom);
      var result = GeometryCombiner.combine(disjointPolys);
      return result;
    }
  }, {
    key: "unionFull",
    value: function unionFull(geom0, geom1) {
      try {
        return geom0.union(geom1);
      } catch (ex) {
        if (ex instanceof TopologyException) return OverlapUnion.unionBuffer(geom0, geom1);else throw ex;
      } finally {}
    }
  }, {
    key: "extractBorderSegments",
    value: function extractBorderSegments(geom0, geom1, env) {
      var segs = new ArrayList();
      OverlapUnion.extractBorderSegments(geom0, env, segs);
      if (geom1 !== null) OverlapUnion.extractBorderSegments(geom1, env, segs);
      return segs;
    }
  }, {
    key: "isUnionOptimized",
    value: function isUnionOptimized() {
      return this._isUnionSafe;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._geomFactory = null;
      this._g0 = null;
      this._g1 = null;
      this._isUnionSafe = null;
      var g0 = arguments[0],
        g1 = arguments[1];
      this._g0 = g0;
      this._g1 = g1;
      this._geomFactory = g0.getFactory();
    }
  }, {
    key: "containsProperly",
    value: function containsProperly() {
      if (arguments.length === 2) {
        var env = arguments[0],
          p = arguments[1];
        if (env.isNull()) return false;
        return p.getX() > env.getMinX() && p.getX() < env.getMaxX() && p.getY() > env.getMinY() && p.getY() < env.getMaxY();
      } else if (arguments.length === 3) {
        var _env = arguments[0],
          p0 = arguments[1],
          p1 = arguments[2];
        return OverlapUnion.containsProperly(_env, p0) && OverlapUnion.containsProperly(_env, p1);
      }
    }
  }, {
    key: "union",
    value: function union(g0, g1) {
      var union = new OverlapUnion(g0, g1);
      return union.union();
    }
  }, {
    key: "intersects",
    value: function intersects(env, p0, p1) {
      return env.intersects(p0) || env.intersects(p1);
    }
  }, {
    key: "overlapEnvelope",
    value: function overlapEnvelope(g0, g1) {
      var g0Env = g0.getEnvelopeInternal();
      var g1Env = g1.getEnvelopeInternal();
      var overlapEnv = g0Env.intersection(g1Env);
      return overlapEnv;
    }
  }, {
    key: "extractBorderSegments",
    value: function extractBorderSegments(geom, env, segs) {
      geom.apply(new ( /*#__PURE__*/function () {
        function _class() {
          _classCallCheck(this, _class);
        }
        _createClass(_class, [{
          key: "filter",
          value: function filter(seq, i) {
            if (i <= 0) return null;
            var p0 = seq.getCoordinate(i - 1);
            var p1 = seq.getCoordinate(i);
            var isBorder = OverlapUnion.intersects(env, p0, p1) && !OverlapUnion.containsProperly(env, p0, p1);
            if (isBorder) {
              var seg = new LineSegment(p0, p1);
              segs.add(seg);
            }
          }
        }, {
          key: "isDone",
          value: function isDone() {
            return false;
          }
        }, {
          key: "isGeometryChanged",
          value: function isGeometryChanged() {
            return false;
          }
        }, {
          key: "interfaces_",
          get: function get() {
            return [CoordinateSequenceFilter];
          }
        }]);
        return _class;
      }())());
    }
  }, {
    key: "unionBuffer",
    value: function unionBuffer(g0, g1) {
      var factory = g0.getFactory();
      var gColl = factory.createGeometryCollection([g0, g1]);
      var union = gColl.buffer(0.0);
      return union;
    }
  }]);
  return OverlapUnion;
}();
export { OverlapUnion as default };